import { bidlClient } from 'src/utils/api'
import { tryQuery } from 'src/utils/queries'

const baseUri = '/api/platform/markets/config/v1'

export type Configuration = {
  key: string
  value: string
}

export type CommodityForOverride = {
  commodityId: string
  commodityName: string
}

export type PlatformCommodityOverride = {
  configurations: Configuration[]
  commodityId: string
  commodityName?: string
}

export type PlatformLocationConfiguration = {
  sourceId: string
  locationName: string
  locationId: string
  datasourceProviderId: string
  configurations: Configuration[]
  commodityOverrides: PlatformCommodityOverride[]
}

export type GetCommoditiesForOverrideRequest = {
  datasourceProviderId: string
}

export type GetLocationConfigurationsRequest = {
  datasourceId: string
}

export type UpdateLocationConfigurationRequest = {
  locationId: string
  configurations: Configuration[]
  commodityOverrides: Array<{
    configurations: Configuration[]
    commodityId: string
  }>
}

export const GetLocationConfigurables = async (tenantId: string) =>
  tryQuery(
    bidlClient.post(
      `${baseUri}/GetLocationConfigurables`,
      {},
      {
        headers: { 'X-Bushel-Tenant': tenantId },
      }
    )
  )

export const GetCommodityOverrideConfigurables = async (tenantId: string) =>
  tryQuery(
    bidlClient.post(
      `${baseUri}/GetCommodityOverrideConfigurables`,
      {},
      {
        headers: { 'X-Bushel-Tenant': tenantId },
      }
    )
  )

export const GetCommoditiesForOverride = async (
  data: GetCommoditiesForOverrideRequest,
  tenantId: string
) =>
  tryQuery(
    bidlClient.post(`${baseUri}/GetCommoditiesForOverride`, data, {
      headers: {
        'Content-Type': 'application/json',
        'X-Bushel-Tenant': tenantId,
      },
    })
  )

export const GetLocationConfigurations = async (
  data: GetLocationConfigurationsRequest,
  tenantId: string
) =>
  tryQuery(
    bidlClient.post(`${baseUri}/GetLocationConfigurations`, data, {
      headers: {
        'Content-Type': 'application/json',
        'X-Bushel-Tenant': tenantId,
      },
    })
  )

export const UpdateLocationConfiguration = async (
  data: UpdateLocationConfigurationRequest,
  tenantId: string
) =>
  tryQuery(
    bidlClient.post(`${baseUri}/UpdateLocationConfiguration`, data, {
      headers: {
        'Content-Type': 'application/json',
        'X-Bushel-Tenant': tenantId,
      },
    })
  )
